<ng-container *ngIf="(home$ | async) as home">
  <view-edit-user-location customMarker="assets/images/location-marker-light.png" (home)="home">
  </view-edit-user-location>
</ng-container>
